export default __webpack_public_path__ + "static/media/MelanieHamilt.0572c7d6.jpg";